import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent {

  @Input() id: string;
  @Input() placeholder: string;
  @Output() searchEvent: EventEmitter<string> = new EventEmitter<string>()
  newSearch: Subject<string> = new Subject<string>();

  constructor() {
    // On New Search
    this.newSearch.pipe(
      debounceTime(1000)
    ).subscribe(model => this.searchEvent.emit(model));
  }

  searchChanged(input) {
    this.newSearch.next(input.value);
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/shared/search-input/search-input.component.ts